/**
 * UI prompt shape for documentation agents (mirrors rocketlane-agentbuilder).
 * Kept local so preview does not depend on agentBuilder remote for transforms.
 */
import type { DocumentationAgentTriggerRegistryConfig } from 'api/document-agent/types';

export enum CanCreatePageOn {
  Manual = 'MANUAL',
  OnEvent = 'ON_EVENT',
}

export enum CreateOnEvent {
  OAccountCreate = 'ON_ACCOUNT_CREATE',
}

export enum SourceSelectionMode {
  Templates = 'TEMPLATES',
  UserInput = 'USER_INPUT',
}

export interface KnowledgeItem {
  id: string;
  name: string;
  type: 'folder' | 'document';
  actualContentType: 'DEFAULT' | 'API_DOC' | 'WEBSITE' | 'FILE';
}

export interface DocumentationAgentPrompt {
  agentId?: number;
  agentName: string;
  documentTemplateId: string;
  sourceSelectionMode: SourceSelectionMode;
  includeMeetings: boolean;
  includeEmails: boolean;
  meetingTemplateIds: string[];
  emailTemplateIds: string[];
  acceptSourcesAtRuntime: boolean;
  canCreatePageOn: CanCreatePageOn;
  createOnEvent: CreateOnEvent | '';
  updateDocument: boolean;
  knowledge: KnowledgeItem[];
  inputs: any[];
  agentTriggerRegistryConfig?: DocumentationAgentTriggerRegistryConfig | null;
  actionEnabled?: boolean;
  automationRegistryBaseline?: string;
}
